export default __webpack_public_path__ + "static/media/google_drive.1093e9ae.svg";